<template>
  <div :class="name">
    <div :class="`${name}__appIcons`">
      <skeleton-basic
        v-for="i in appCounts"
        :key="i"
        :class="`${name}__icon`"
        height="40px"
        width="40px"
        style="margin-right: 24px;"
      />
    </div>
    <skeleton-basic :class="`${name}__label`" height="22px" width="50px" />
    <skeleton-basic height="462px" width="260px" style="border-radius: 6px;" />
    <div :class="`${name}__textContent`">
      <skeleton-basic :class="`${name}__text`" height="12px" width="258px" />
      <skeleton-basic :class="`${name}__text`" height="12px" width="258px" />
      <skeleton-basic :class="`${name}__text`" height="12px" width="258px" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import SkeletonBasic from '@/components/skeleton/basic.vue';

const name = 'ttam-preview-skeleton';

export default defineComponent({
  name,
  components: {
    SkeletonBasic,
  },
  setup() {
    const appCounts = 2;

    return {
      name,
      appCounts,
    };
  },
});
</script>

<style lang="scss">
$name: 'ttam-preview-skeleton';

.#{$name} {
  &__appIcons {
    display: flex;
  }
  &__icon {
    border-radius: 6px;
  }
  &__label {
    padding: 12px 0;
    margin: 12px 0;
  }
  &__textContent {
    margin-top: 8px;
  }
  &__text {
    margin-top: 4px;
  }
}
</style>
